<div class="container">
  <div class="headerTitle">Actualización de cuentas bancarias</div>
  <div class="detail">
    Te informamos que ahora podrás efectuar el
    <strong class="bold"
      >alta, baja y consulta de tus cuentas bancarias de retiro a través de la
      aplicación.</strong
    >
    Las cuentas aquí reflejadas, sustituyen lo anteriormente mostrado en la
    carátula de tu Contrato de Intermediación Bursátil.
    <br />
    <br />Asimismo, te informamos que hemos realizado
    <strong class="bold"
      >ciertas modificaciones al Contrato de Intermediación Bursátil,</strong
    >
    por lo que el contrato que mantienes celebrado con nosotros se considerará
    modificado en dichos términos, y se encuentra disponible para ser consultado
    en
    <strong class="bold"
      ><a href="https://www.gbm.com" target="_blank" rel="noopener noreferrer"
        >www.gbm.com</a
      ></strong
    >
  </div>
  <div class="action">
    <button
      [ngClass]="[
        'button-terms',
        activeButton ? 'register-active' : 'register-inactive'
      ]"
      (click)="acceptTerms()"
    >
      <div class="lds-ring" *ngIf="processingTyC">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span>Entendido</span>
    </button>
  </div>
</div>
